/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/vaccination_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./vaccination_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient =
  function VaccinationServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient =
  function VaccinationServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListVaccinationsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListVaccinationsResponse>}
 */
const methodDescriptor_VaccinationService_ListVaccinations =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/ListVaccinations",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListVaccinationsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListVaccinationsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListVaccinationsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListVaccinationsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListVaccinationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListVaccinationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListVaccinationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.listVaccinations =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListVaccinations",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_ListVaccinations,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListVaccinationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListVaccinationsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.listVaccinations =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListVaccinations",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_ListVaccinations
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetVaccinationRequest,
 *   !proto.stronachgroup.first.racehorse360.Vaccination>}
 */
const methodDescriptor_VaccinationService_GetVaccination =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/GetVaccination",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetVaccinationRequest,
    stronachgroup_first_racehorse360_messages_pb.Vaccination,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetVaccinationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Vaccination.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetVaccinationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Vaccination)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Vaccination>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.getVaccination =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/GetVaccination",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_GetVaccination,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetVaccinationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Vaccination>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.getVaccination =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/GetVaccination",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_GetVaccination
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteVaccinationRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_VaccinationService_DeleteVaccination =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/DeleteVaccination",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteVaccinationRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteVaccinationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteVaccinationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.deleteVaccination =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/DeleteVaccination",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_DeleteVaccination,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteVaccinationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.deleteVaccination =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/DeleteVaccination",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_DeleteVaccination
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListVaccinationCommentsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListVaccinationCommentsResponse>}
 */
const methodDescriptor_VaccinationService_ListVaccinationComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/ListVaccinationComments",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListVaccinationCommentsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListVaccinationCommentsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListVaccinationCommentsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListVaccinationCommentsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListVaccinationCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListVaccinationCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListVaccinationCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.listVaccinationComments =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListVaccinationComments",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_ListVaccinationComments,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListVaccinationCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListVaccinationCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.listVaccinationComments =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListVaccinationComments",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_ListVaccinationComments
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateVaccinationCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.VaccinationComment>}
 */
const methodDescriptor_VaccinationService_CreateVaccinationComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/CreateVaccinationComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateVaccinationCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.VaccinationComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateVaccinationCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.VaccinationComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateVaccinationCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.VaccinationComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.VaccinationComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.createVaccinationComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/CreateVaccinationComment",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_CreateVaccinationComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateVaccinationCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.VaccinationComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.createVaccinationComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/CreateVaccinationComment",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_CreateVaccinationComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_VaccinationService_DeleteVaccinationComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/DeleteVaccinationComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteVaccinationCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.deleteVaccinationComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/DeleteVaccinationComment",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_DeleteVaccinationComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.deleteVaccinationComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/DeleteVaccinationComment",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_DeleteVaccinationComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest,
 *   !proto.stronachgroup.first.racehorse360.VaccinationComment>}
 */
const methodDescriptor_VaccinationService_UpdateVaccinationComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/UpdateVaccinationComment",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UpdateVaccinationCommentRequest,
    stronachgroup_first_racehorse360_messages_pb.VaccinationComment,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.VaccinationComment.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.VaccinationComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.VaccinationComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.updateVaccinationComment =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/UpdateVaccinationComment",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_UpdateVaccinationComment,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.VaccinationComment>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.updateVaccinationComment =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/UpdateVaccinationComment",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_UpdateVaccinationComment
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.AddVaccineInjectionRequest,
 *   !proto.stronachgroup.first.racehorse360.Injection>}
 */
const methodDescriptor_VaccinationService_AddVaccineInjection =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/AddVaccineInjection",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.AddVaccineInjectionRequest,
    stronachgroup_first_racehorse360_messages_pb.Injection,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.AddVaccineInjectionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Injection.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.AddVaccineInjectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Injection)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Injection>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.addVaccineInjection =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/AddVaccineInjection",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_AddVaccineInjection,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.AddVaccineInjectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Injection>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.addVaccineInjection =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/AddVaccineInjection",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_AddVaccineInjection
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.AddBoosterInjectionRequest,
 *   !proto.stronachgroup.first.racehorse360.Injection>}
 */
const methodDescriptor_VaccinationService_AddBoosterInjection =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/AddBoosterInjection",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.AddBoosterInjectionRequest,
    stronachgroup_first_racehorse360_messages_pb.Injection,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.AddBoosterInjectionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Injection.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.AddBoosterInjectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Injection)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Injection>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.addBoosterInjection =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/AddBoosterInjection",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_AddBoosterInjection,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.AddBoosterInjectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Injection>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.addBoosterInjection =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/AddBoosterInjection",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_AddBoosterInjection
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListInjectionsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListInjectionsResponse>}
 */
const methodDescriptor_VaccinationService_ListInjections =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/ListInjections",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListInjectionsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListInjectionsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListInjectionsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListInjectionsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListInjectionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListInjectionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListInjectionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.listInjections =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListInjections",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_ListInjections,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListInjectionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListInjectionsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.listInjections =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListInjections",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_ListInjections
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteInjectionRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_VaccinationService_DeleteInjection =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/DeleteInjection",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteInjectionRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteInjectionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteInjectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.deleteInjection =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/DeleteInjection",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_DeleteInjection,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteInjectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.deleteInjection =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/DeleteInjection",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_DeleteInjection
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UpdateInjectionRequest,
 *   !proto.stronachgroup.first.racehorse360.Injection>}
 */
const methodDescriptor_VaccinationService_UpdateInjection =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/UpdateInjection",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UpdateInjectionRequest,
    stronachgroup_first_racehorse360_messages_pb.Injection,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UpdateInjectionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.Injection.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateInjectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.Injection)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.Injection>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.updateInjection =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/UpdateInjection",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_UpdateInjection,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateInjectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.Injection>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.updateInjection =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/UpdateInjection",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_UpdateInjection
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListMedicinesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListMedicinesResponse>}
 */
const methodDescriptor_VaccinationService_ListMedicines =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/ListMedicines",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListMedicinesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListMedicinesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListMedicinesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListMedicinesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListMedicinesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListMedicinesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListMedicinesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.VaccinationServiceClient.prototype.listMedicines =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListMedicines",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_ListMedicines,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListMedicinesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListMedicinesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.VaccinationServicePromiseClient.prototype.listMedicines =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListMedicines",
      request,
      metadata || {},
      methodDescriptor_VaccinationService_ListMedicines
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
